import ReviewAddEditViewController from './addedit/ReviewAddEditViewController';
import ReviewsMainController from './main/ReviewTableViewController';

export default { ReviewsMainController, ReviewAddEditViewController } 


// WEBPACK FOOTER //
// ./src/app/dashboard/reviews/index.ts